import { MutationOptions, useMutation } from 'react-query';
import { SetDataStoreInCacheRequest, SetDataStoreInCacheResponse } from './types';
import { CustomizationFeatureValidator } from '@weave/schema-gen-ts/dist/schemas/customization-feature-validator/v1/customization_feature_validator.pb';
import { authorizedFetch } from '../../helpers/utils';

export function useSetCustomizationFlagDataStore(
  options?: MutationOptions<
    SetDataStoreInCacheResponse,
    Error,
    SetDataStoreInCacheRequest
  >
) {
  return useMutation({
    mutationFn: (request: SetDataStoreInCacheRequest) =>
      CustomizationFeatureValidator.SetDataStoreInCache(authorizedFetch(), request),
    ...options,
  });
}
